module.exports = __webpack_public_path__ + "static/img/fu_zhuang_fu_shi.37762ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fu_zhuang_fu_shi.png
// module id = 7ybh
// module chunks = 18